export const getUrl = (envName, path) => {
  // XXX: Currently SRE gives us the hostname that handle the API
  // the http(s) part is missing. So we have to do this on our side ...
  const base = process.env[envName];

  if (base === undefined || base === '') {
    return path;
  }

  if (base.match(/^https?:/)) {
    return `${base}${path}`;
  }

  // XXX: we use http wich wont work on client side, but currently this
  // is the only option we got to make things work.
  return `http://${base}${path}`;

  // TODO: please revert this ugly commit and find a proper solution
};
